import { subjects_for_selectQuery } from '@app-types/graphql-types';
import { HSMSSelectOption } from '@components/shared';

export const getSubjectsForSelect = (subjects: subjects_for_selectQuery['subject']): HSMSSelectOption[] => {
  if (subjects) {
    const subjectsForSelect = subjects.map((subject) => {
      return {
        value: subject.id,
        label: `${subject.code} - ${subject.name}`,
      };
    });

    return subjectsForSelect.sort((firstValue, secondValue) => firstValue.label.localeCompare(secondValue.label));
  }

  return [];
};
